import { render, staticRenderFns } from "./input-payment-type.vue?vue&type=template&id=6689d685"
import script from "./input-payment-type.vue?vue&type=script&lang=js"
export * from "./input-payment-type.vue?vue&type=script&lang=js"
import style0 from "./input-payment-type.vue?vue&type=style&index=0&id=6689d685&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports